import { ReactElement } from "react";
import styles from "./aboutStats.module.scss";

export const AboutStats = (props: Props): ReactElement => {
  return (
    <section className={styles.base}>
      <div className={styles.wrapper}>
        <img
          src={props.imageUrl}
          loading="lazy"
          alt=""
          className={styles.image}
        />
        <div className={styles.content}>
          <div className={styles.headingAndDesc}>
            <p className={styles.title}>{props.title}</p>
            <p className={styles.desc}>{props.desc}</p>
          </div>

          <div className={styles.items}>
            {props.items?.map((item, i) => (
              <div className={styles.item} key={i}>
                <p className={styles.itemValue}>{item.value}</p>
                <p className={styles.itemLabel}>{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

interface Props {
  imageUrl: string;
  title: string;
  desc: string;
  items: {
    value: string;
    label: string;
  }[];
}
